import {Component, effect, inject, Renderer2} from '@angular/core';
import {EnvironmentService} from '../../services/environment.service';
import {UserCentricsService, WALK_ME} from '../../services/user-centrics.service';

declare global {
  interface Window {
    WalkMeAPI?: {
      changeLanguage?: (language: string) => void;
      [key: string]: any;
    };
  }
}

@Component({
  selector: 'cov-walk-me',
  imports: [],
  templateUrl: './walk-me.component.html',
  styleUrl: './walk-me.component.scss',
})
export class WalkMeComponent {
  // SERVICE
  private renderer = inject(Renderer2);
  private environmentService = inject(EnvironmentService);
  private userCentricsService = inject(UserCentricsService);

  constructor() {
    effect(() => {
      if (
        this.environmentService.isWalkMeEnabled &&
        this.userCentricsService.hasConsent(WALK_ME)()
      ) {
        this.initialize();
      }
    });
  }

  private initialize() {
    const walkMe = this.renderer.createElement('script');
    walkMe.text = `
      (function() {
        var walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = '${this.environmentService.getWalkMeSource()}';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = {smartLoad:true};
      })();
    `;
    this.renderer.appendChild(document.head, walkMe);

    // TODO: Temporarily disabled as language changes currently force a page reload (quick fix)
    // We didn't implement this inside of the locale service because WalkMe can be disabled on environments and functionality should be handled at one place if possible
    // this.localeService.language$.pipe(takeUntil(this.destroy$)).subscribe((language) => {
    //   if (window.WalkMeAPI?.changeLanguage) {
    //     window.WalkMeAPI.changeLanguage(language);
    //   }
    // });
  }
}
